import jalaliMoment from 'jalali-moment';

export function convertToPersianDate(date: string, format?: string): string {
   let persianFormat = format ? format : 'jYYYY/jMM/jDD HH:mm:ss'
  // Convert the Gregorian date to a Persian (Jalali) date using jalali-moment
  const persianMoment = jalaliMoment(date, 'YYYY-MM-DDTHH:mm:ssZZ');

  // Format the Persian date as a string (optional)
  const formattedPersianDate = persianMoment.format(persianFormat);

  return formattedPersianDate;
}
